import { FlagIcon } from "@heroicons/react/outline";

export const SlideFlagIcon: React.FC<{ height?: string }> = ({
  height = "1.25em",
}) => <FlagIcon {...{ height, className: "slideFlagIcon" }} />;
